import { Briefcase, Layers, Target } from "lucide-react";
import { Link } from "react-router-dom";

const CARDS = [
  {
    icon: Briefcase,
    title: "Experiencia ejecutiva real",
    text: "He estado del otro lado de la mesa. Entiendo la presión de tener clientes, equipos, objetivos y múltiples prioridades ocurriendo al mismo tiempo. Por eso busco que las herramientas funcionen en el mundo real, no solamente en una presentación.",
  },
  {
    icon: Layers,
    title: "Implementación 100% pragmática",
    text: "Una empresa que crece inevitablemente se vuelve más compleja. El objetivo no es agregar más burocracia, sino simplificar, clarificar responsabilidades y construir una forma más disciplinada de operar.",
  },
  {
    icon: Target,
    title: "Lo implemento yo mismo, en tu empresa",
    text: "Asumo personalmente el desafío de entrenarte a ti y a tu equipo de liderazgo en las prácticas de EOS. No es una consultoría tradicional ni delego el proceso en terceros: trabajo directamente con ustedes de principio a fin.",
  },
];

export default function WhyCarlos({ cta }) {
  return (
    <section id="sobre-mi" data-testid="why-carlos-section" className="section-padding bg-slate-50/60">
      <div className="container-eos">
        <div className="max-w-3xl reveal">
          <span className="eyebrow">Por qué Carlos Garcín</span>
          <h2 className="mt-3 font-display font-extrabold text-3xl sm:text-4xl lg:text-5xl text-navy-800 leading-tight">
            Te acompañaré en el proceso completo de implementación de EOS,{" "}
            <span className="text-[#F26522]">con un foco práctico y de máximo valor para tu empresa.</span>
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-5 lg:gap-7">
          {CARDS.map((c, i) => (
            <article
              key={i}
              data-testid={`why-card-${i + 1}`}
              className="card-soft p-7 reveal"
              style={{ transitionDelay: `${i * 90}ms` }}
            >
              <div className="w-12 h-12 rounded-lg bg-[#F26522]/10 flex items-center justify-center">
                <c.icon className="w-5 h-5 text-[#F26522]" strokeWidth={1.7} />
              </div>
              <h3 className="mt-6 font-display font-bold text-xl text-navy-800 leading-snug">
                {c.title}
              </h3>
              <p className="mt-3 text-slate-600 leading-relaxed">{c.text}</p>
            </article>
          ))}
        </div>

        <div className="mt-6 reveal flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <Link
            to="/implementador-eos"
            data-testid="why-carlos-implementador-link"
            className="inline-flex items-center gap-1.5 text-[#F26522] font-semibold hover:underline"
          >
            Te cuento cómo implemento EOS →
          </Link>
          {cta}
        </div>
      </div>
    </section>
  );
}
